/** Single source of truth for terms version and update date. */
export const CURRENT_TERMS_VERSION = 1;
export const TERMS_UPDATED_AT = '2026-01-15';

const CURRENT_TERMS_UPDATED_AT = new Date(TERMS_UPDATED_AT);

/** Whether terms accepted at this time cover the current terms; `null` means never accepted. */
export function acceptedCurrentTerms(acceptedTermsAt: string | null): boolean {
  return acceptedTermsAt !== null && new Date(acceptedTermsAt) >= CURRENT_TERMS_UPDATED_AT;
}
